export default __webpack_public_path__ + "static/screeny-130-gpz-unica-m-7-20fb6dfabbcc91b620b083ccae50c6a5.jpg";